const BASE = process.env.API_URL ?? "http://localhost:3001/api";

const authHeaders = () => ({
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
});

export const api = {
    // Public
    getPosts: () => fetch(`${BASE}/posts`).then((r) => r.json()),
    getPost: (slug: string) => fetch(`${BASE}/posts/${slug}`).then((r) => r.json()),

    // Auth
    login: (username: string, password: string) =>
        fetch(`${BASE}/auth/login`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ username, password }),
        }).then((r) => r.json()),

    // Admin
    getAllPosts: () =>
        fetch(`${BASE}/posts/admin/all`, { headers: authHeaders() }).then((r) => r.json()),
    createPost: (data: object) =>
        fetch(`${BASE}/posts`, {
            method: "POST",
            headers: authHeaders(),
            body: JSON.stringify(data),
        }).then((r) => r.json()),
    updatePost: (id: string, data: object) =>
        fetch(`${BASE}/posts/${id}`, {
            method: "PUT",
            headers: authHeaders(),
            body: JSON.stringify(data),
        }).then((r) => r.json()),
    deletePost: (id: string) =>
        fetch(`${BASE}/posts/${id}`, {
            method: "DELETE",
            headers: authHeaders(),
        }).then((r) => r.json()),
};
